/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Hero_TitleInputs */

const en_business_hero_title = /** @type {(inputs: Business_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening for Business`)
};

const es_business_hero_title = /** @type {(inputs: Business_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening para empresas`)
};

/**
* | output |
* | --- |
* | "Listening for Business" |
*
* @param {Business_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_hero_title = /** @type {((inputs?: Business_Hero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Hero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_hero_title(inputs)
	return en_business_hero_title(inputs)
});